import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'payment.card.holder.information.state.options.empty': {
    id: 'payment.card.holder.information.state.options.empty',
    defaultMessage: 'Choose state/province',
    description: 'Option for empty value on card holder information state/province field.',
  },
});

export default messages;
